import React, { useRef } from 'react';
import c from 'classnames';
import Picture from '..';

import './style.scss';

const PictureBackground = ({ className, children, ...props }) => {
  const bgElem = useRef(null);
  const imgElement = useRef(null);
  const onLoad = (e) => {
    const src = typeof imgElement.current.currentSrc !== 'undefined' ? imgElement.current.currentSrc : imgElement.current.src;
    bgElem.current.style.backgroundImage = `url("${src}")`;
  };

  const classes = c('PictureBackground', className);
  return (
    <div
      className={classes}
      data-responsive-background-image
      ref={bgElem}
    >
      <Picture
        className="PictureBackground__picture"
        onLoadFunction={(e) => onLoad(e)}
        imageRef={imgElement}
        {...props}
      />
      {children}
    </div>
  );
};

export default PictureBackground;
